import React, { useState, useEffect } from 'react';
import { CurrencyIcon } from 'lucide-react';

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../ui/dialog";
import { Skeleton } from "../../ui/skeleton"
import { Label } from "../../ui/label"
import { RadioGroup, RadioGroupItem } from "../../ui/radio-group"
import { Input } from "../../ui/input"
import {BACKEND_API_URL} from "../../../env";
import TagManager from "react-gtm-module";

const instrumentCategories = ['All', 'Forex', 'Crypto', 'Index']

function InstrumentPicker({ setInstrument, currentInstrument, instruments, setVirtualAssistantSettings, virtualAssistantSettings }) {
    /* Fetches instruments from the API and displays them on the popup as a list.
    For now its hard coded for 10 basics instruments since aggregation of candles every second is very resource consuming */
  
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [loading, setLoading] = useState(false);

    const handleOpenChange = (isOpen) => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'instrument_picker_dialog',
                action: isOpen ? 'open' : 'close',
                label: currentInstrument.display_name
            },
        });
    };

    const handleListItemClick = async (value) => {
        
        const currency = value.display_name
        let timeframe = virtualAssistantSettings.channelTimeframe
        
        if(timeframe == 300) {
            timeframe = "5m"
        }

        if(timeframe == 900) {
            timeframe = "15m"
        }

        if(timeframe == 3600) {
            timeframe = "1h"
        }
        
        // sensitivity => arrows
        // length => manual

        const ENDPOINT_URL = `${BACKEND_API_URL}/api/currency-timeframe-matches`;
        try {
            const params = new URLSearchParams({
                currency: String(currency),
                timeframe: String(timeframe),
            });
            const url = `${ENDPOINT_URL}?${params.toString()}`;            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: "include"
            });
            
            if (response.status === 200) {
                const data = await response.json();
                console.log('Response data (currency-timeframe-matches):', data);
                
                setVirtualAssistantSettings({
                    ...virtualAssistantSettings,
                    sensitivity: data.arrows,
                    length: data.manual,
                });
            }
            
        } catch (error) {
            console.error('Error sending message (currency-timeframe-matches):', error);
        } finally {
        }
        
        setInstrument(value);
    };

    const filteredInstruments = instruments.filter((instrument) => {
        const matchesSearch = searchTerm
            .toLowerCase()
            .split(' ')
            .every(term => instrument.display_name.toLowerCase().includes(term));

        const matchesCategory = selectedCategory === 'All' || instrument.type === selectedCategory.toLowerCase();
        return matchesSearch && matchesCategory;
    });

    return <>
        <Dialog onOpenChange={handleOpenChange}>
            <DialogTrigger>
                <div
                    className="flex items-center space-x-2 focus:ring-2 focus:ring-offset-2 focus:ring-white rounded-md cursor-pointer"
                >
                    <CurrencyIcon size={20} />
                    <span>{currentInstrument.display_name}</span>
                </div>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Choose the instrument</DialogTitle>
                </DialogHeader>
                <Input
                    label="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <div className="flex space-x-2">
                    {instrumentCategories.map((category) => (
                        <button
                            key={category}
                            className={`rounded-md px-2 py-1 text-sm ${
                                selectedCategory === category ? 'bg-lt-dark-blue text-white' : 'bg-gray-200'
                            }`}
                            onClick={() => setSelectedCategory(category)}
                        >
                            {category}
                        </button>
                    ))}
                </div>
                {loading ? (
                    <div className="space-y-2">
                        <Skeleton className="h-4 w-[250px]" />
                        <Skeleton className="h-4 w-[200px]" />
                        <Skeleton className="h-4 w-[200px]" />
                        <Skeleton className="h-4 w-[200px]" />
                    </div>
                ) : (
                    <RadioGroup defaultValue={currentInstrument.name} className="max-h-80 overflow-y-scroll">
                        {filteredInstruments.map((instrument) => (
                            <div key={instrument.name} className="flex items-center space-x-2">
                                <RadioGroupItem onClick={() => handleListItemClick(instrument)} value={instrument.name} id={instrument.name} checked={instrument.name === currentInstrument.name} />
                                <Label htmlFor={instrument.name}>{instrument.display_name}</Label>
                            </div>
                        ))}
                    </RadioGroup>

                )}
            </DialogContent>
        </Dialog>
    </>;
}

export default InstrumentPicker;